module.exports = __webpack_public_path__ + "img/15-2.8dbc9fdd.jpg";